import { Route, Routes } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { ComplaintsBookPage } from './pages/ComplaintsBookPage';
import { HomePage } from './pages/HomePage';
import { MedicalNegligenceLandingPage } from './pages/MedicalNegligenceLandingPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsPage } from './pages/TermsPage';
import { WhyChoosePage } from './pages/WhyChoosePage';

export default function App() {
  return (
    <Routes>
      <Route path="negligencia-medica" element={<MedicalNegligenceLandingPage />} />
      <Route element={<SiteLayout />}>
        <Route index element={<HomePage />} />
        <Route path="sobre-nosotros" element={<AboutPage />} />
        <Route path="por-que-elegirnos" element={<WhyChoosePage />} />
        <Route path="contacto" element={<ContactPage />} />
        <Route path="libro-de-reclamaciones" element={<ComplaintsBookPage />} />
        <Route path="politica-de-privacidad" element={<PrivacyPolicyPage />} />
        <Route path="terminos" element={<TermsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  );
}
